import type { SpinResponse } from "@slot/client-engine";
import { fx, spinFixture } from "@slot/game-shell";

const mask = (indices: number[]): string =>
  Array.from({ length: 20 }, (_, i) => (indices.includes(i) ? "1" : "0")).join("");

/**
 * The bare free-spins trigger on this game's 5×4 grid: three FS land on the bottom row, the scatter
 * state pulses them, the trigger panel awards the feature and the round ends there (the feature
 * itself plays in `fs_free_spins`). Rebuilt from the template's 6×5 layout, which never fit this grid.
 */
export function baseFixtureFeatureTrigger(): SpinResponse {
  return spinFixture("base-001")
    .balance("EUR", "100000")
    .event("reveal", 0, (e) => {
      e.reelSet("default").accumulatedWinAfter("0").gridRows([
        ["L1", "H2", "H3", "H4", "L5"],
        ["L4", "L5", "H4", "H3", "H2"],
        ["H1", "L1", "H1", "H1", "L1"],
        ["H2", "FS", "FS", "FS", "H3"],
      ]);

      const s = fx.spinBoundaryStart("base:1", "base");
      e.action(s.type, s.payload, { actionPhaseName: s.phase, debugTag: "start" });

      const sc = fx.presentScatterState({ positionMask: mask([16, 17, 18]), scatterCount: "3" });
      e.action(sc.type, sc.payload);

      const fw = fx.bonusFeatureWon("super_bonus_buy", "3");
      e.action(fw.type, fw.payload);

      const end = fx.spinBoundaryEnd("base:1", "0");
      e.action(end.type, end.payload, { actionPhaseName: end.phase, debugTag: "end" });
    })
    .build();
}
